import React, { useEffect, useState } from 'react';
import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage';
import { SecondaryBase } from './../Commons/SecondaryBase';
import { GetConfig, SaveConfig, UploadMedia } from './../../../utilities/BL/Rollers'; // Usamos la misma lógica de subida de Arma la imagen
import * as AttendanceBL from './../../../utilities/BL/Attendance';

// Componente helper para subida de archivos (reutilizado de Arma la imagen)
const DragAndDropField = ({ label, targetField, type, value, onUpload, onClear, getMediaUrl }) => {
    const [isDragOver, setIsDragOver] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = () => {
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const file = e.dataTransfer.files[0];
        if (file) {
            onUpload(file, type, targetField);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            onUpload(file, type, targetField);
        }
    };

    return (
        <div className="mb-3">
            {label && <label className="form-label fw-bold text-dark">{label}:</label>}
            <div 
                className={`border border-2 border-dashed rounded-3 p-3 text-center cursor-pointer transition ${isDragOver ? 'border-primary bg-light' : 'border-secondary bg-white'}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById(`file-input-${targetField}`).click()}
            >
                <i className="bi bi-cloud-arrow-up-fill text-primary fs-3"></i>
                <p className="small text-muted mb-0 mt-1">Arrastra tu archivo aquí, o haz clic para examinar</p>
                <input 
                    id={`file-input-${targetField}`}
                    type="file" 
                    className="d-none"
                    onChange={handleFileChange}
                />
            </div>
            {value && (
                <div className="mt-2 text-center bg-light p-2 rounded border position-relative">
                    <button 
                        type="button" 
                        className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1" 
                        style={{ padding: '0.1rem 0.35rem', zIndex: 10 }}
                        onClick={(e) => {
                            e.stopPropagation(); // Evita que se abra el selector de archivos
                            if (onClear) onClear(targetField);
                        }}
                        title="Eliminar archivo"
                    >
                        <i className="bi bi-trash"></i>
                    </button>
                    {type === 'logo' || value.endsWith('.png') || value.endsWith('.jpg') || value.endsWith('.jpeg') ? (
                        <img src={getMediaUrl(value)} alt="Preview" style={{ maxHeight: '60px', objectFit: 'contain' }} />
                    ) : (
                        <span className="small text-truncate d-block text-dark pe-4">{value.split('/').pop()}</span>
                    )}
                </div>
            )}
        </div>
    );
};

export const AttendanceAdmin = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage();
    const [isLoading, setIsLoading] = useState(false);
    const [configForm, setConfigForm] = useState({
        id: 0,
        brandLogoUrl: '',
        charLeftUrl: '',
        charRightUrl: '',
        normalSoundUrl: '',
        winnerSoundUrl: '',
        waitingTitle: 'REGISTRA TU ASISTENCIA',
        welcomeTitle: 'Bienvenid@',
        winnerMessageTemplate: '¡Felicidades! Por ser el abonado #{numero} en registrar asistencia has ganado.',
        requireScan: true,
        winnerSelectionMode: 'Frequency',
        exactWinnerPositions: '',
        winnerFrequency: 30,
        nextClickIsWinner: false,
        backgroundType: 'color',
        backgroundColor: '#050508',
        backgroundUrl: '',
        messageDuration: 5
    });

    const [activeTab, setActiveTab] = useState('config'); // 'config', 'history'
    const [records, setRecords] = useState([]);

    useEffect(() => {
        loadConfig();
    }, []);

    useEffect(() => {
        if (activeTab === 'history') {
            loadRecords();
        }
    }, [activeTab]);

    const loadRecords = async () => {
        try {
            const res = await AttendanceBL.GetRecords();
            if (res) {
                setRecords(res);
            }
        } catch (error) {
            showMessage('Error al cargar historial', MESSAGE_TYPE.ERROR);
        }
    };

    const handleDeleteRecord = async (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este registro? La numeración de todos los registros posteriores se reajustará automáticamente.')) {
            showMessage('Eliminando registro...', MESSAGE_TYPE.INFO);
            try {
                const res = await AttendanceBL.DeleteRecord(id);
                if (res && res.success) {
                    showMessage('✅ Registro eliminado y numeración reordenada', MESSAGE_TYPE.SUCCESS);
                    loadRecords();
                } else {
                    showMessage('❌ Error al eliminar el registro', MESSAGE_TYPE.ERROR);
                }
            } catch (e) {
                showMessage('❌ Error de conexión al eliminar', MESSAGE_TYPE.ERROR);
            }
        }
    };

    const loadConfig = async () => {
        setIsLoading(true);
        try {
            const res = await AttendanceBL.GetConfig();
            if (res) {
                setConfigForm(res);
            }
        } catch (error) {
            showMessage('Error al cargar la configuración', MESSAGE_TYPE.ERROR);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveConfig = async (updatedForm = configForm) => {
        showMessage('Guardando cambios...', MESSAGE_TYPE.INFO);
        try {
            const res = await AttendanceBL.SaveConfig(updatedForm);
            if (res && res.success) {
                showMessage('✅ Configuración guardada con éxito', MESSAGE_TYPE.SUCCESS);
            } else {
                showMessage('❌ Error al guardar la configuración', MESSAGE_TYPE.ERROR);
            }
        } catch (e) {
            showMessage('❌ Error de conexión al guardar', MESSAGE_TYPE.ERROR);
        }
    };

    const updateField = (field, value) => {
        const updated = { ...configForm, [field]: value };
        setConfigForm(updated);
        handleSaveConfig(updated);
    };

    const handleUploadMedia = async (file, type, targetField) => {
        showMessage('Subiendo y optimizando archivo...', MESSAGE_TYPE.INFO);
        const res = await UploadMedia(file, type);
        if (res && res.success) {
            showMessage('✅ Archivo cargado', MESSAGE_TYPE.SUCCESS);
            updateField(targetField, res.url);
        } else {
            showMessage('❌ Error al subir archivo', MESSAGE_TYPE.ERROR);
        }
    };

    const handleClearMedia = (targetField) => {
        updateField(targetField, '');
    };

    const getMediaUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const apiBase = (process.env.REACT_APP_API_URL || '').replace('/api/', '/').replace('/api', '/');
        const url = `${apiBase}${path}`;
        return url.replace(/([^:]\/)\/+/g, "$1");
    };

    return (
        <SecondaryBase actionToExecute={getOutOfTheDynamic}>
            <div className="mb-4 text-center text-dark">
                <p className="fs-2 text-uppercase fw-bold m-0" style={{ letterSpacing: '2px' }}>
                    <i className="bi bi-clipboard-check text-warning"></i> Registro de Asistencia
                </p>
                <span className="small text-muted">Configura recursos y reglas para el módulo de acceso</span>
            </div>

            {/* Selector de Pestañas */}
            <div className="d-flex justify-content-center gap-3 mb-4">
                <button 
                    className={`btn px-4 py-2 fw-bold ${activeTab === 'config' ? 'btn-primary text-white shadow' : 'btn-outline-secondary'}`}
                    onClick={() => setActiveTab('config')}
                >
                    <i className="bi bi-sliders"></i> Ajustes de la Dinámica
                </button>
                <button 
                    className={`btn px-4 py-2 fw-bold ${activeTab === 'history' ? 'btn-primary text-white shadow' : 'btn-outline-secondary'}`}
                    onClick={() => setActiveTab('history')}
                >
                    <i className="bi bi-clock-history"></i> Historial de Asistencias
                </button>
            </div>

            {activeTab === 'config' && (
                <div className="row text-start text-dark">
                {/* Panel Izquierdo: Parametrización */}
                <div className="col-md-7 mb-4">
                    <div className="bg-white p-4 rounded-4 border shadow-sm h-100">
                        <h5 className="fw-bold mb-4 text-primary"><i className="bi bi-gear-fill"></i> Configuración General</h5>

                        {/* TÍTULO DE ESPERA */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">Texto Pantalla Espera:</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={configForm.waitingTitle}
                                onChange={(e) => setConfigForm({ ...configForm, waitingTitle: e.target.value })}
                                onBlur={() => updateField('waitingTitle', configForm.waitingTitle)}
                            />
                        </div>

                        {/* TÍTULO DE BIENVENIDA */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">Texto Bienvenida Normal:</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={configForm.welcomeTitle}
                                onChange={(e) => setConfigForm({ ...configForm, welcomeTitle: e.target.value })}
                                onBlur={() => updateField('welcomeTitle', configForm.welcomeTitle)}
                            />
                        </div>

                        {/* MENSAJE DE GANADOR */}
                        <div className="mb-4">
                            <label className="form-label fw-bold">Texto Mensaje Ganador (usa {"{numero}"} para insertar el contador):</label>
                            <textarea 
                                className="form-control" 
                                rows="2"
                                value={configForm.winnerMessageTemplate}
                                onChange={(e) => setConfigForm({ ...configForm, winnerMessageTemplate: e.target.value })}
                                onBlur={() => updateField('winnerMessageTemplate', configForm.winnerMessageTemplate)}
                            />
                        </div>

                        <hr />

                        {/* RECURSOS MULTIMEDIA */}
                        <h5 className="fw-bold mb-3 mt-4 text-primary"><i className="bi bi-palette-fill"></i> Recursos Visuales</h5>
                        <div className="row">
                            <div className="col-md-4">
                                <DragAndDropField 
                                    label="Logo Superior" 
                                    targetField="brandLogoUrl" 
                                    type="logo" 
                                    value={configForm.brandLogoUrl}
                                    onUpload={handleUploadMedia}
                                    onClear={handleClearMedia}
                                    getMediaUrl={getMediaUrl}
                                />
                            </div>
                            <div className="col-md-4">
                                <DragAndDropField 
                                    label="Personaje Izquierdo" 
                                    targetField="charLeftUrl" 
                                    type="logo" 
                                    value={configForm.charLeftUrl}
                                    onUpload={handleUploadMedia}
                                    onClear={handleClearMedia}
                                    getMediaUrl={getMediaUrl}
                                />
                            </div>
                            <div className="col-md-4">
                                <DragAndDropField 
                                    label="Personaje Derecho" 
                                    targetField="charRightUrl" 
                                    type="logo" 
                                    value={configForm.charRightUrl}
                                    onUpload={handleUploadMedia}
                                    onClear={handleClearMedia}
                                    getMediaUrl={getMediaUrl}
                                />
                            </div>
                        </div>

                        <hr />

                        {/* CONFIGURACIÓN DEL FONDO */}
                        <h5 className="fw-bold mb-3 mt-4 text-primary"><i className="bi bi-window-fill"></i> Personalización de Fondo</h5>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Tipo de Fondo:</label>
                                <select 
                                    className="form-select"
                                    value={configForm.backgroundType || 'color'}
                                    onChange={(e) => updateField('backgroundType', e.target.value)}
                                >
                                    <option value="color">Color Sólido</option>
                                    <option value="image">Imagen</option>
                                    <option value="video">Video</option>
                                </select>
                            </div>
                            {configForm.backgroundType === 'color' ? (
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Color del Fondo:</label>
                                    <div className="d-flex gap-2">
                                        <input 
                                            type="color" 
                                            className="form-control form-control-color" 
                                            style={{ width: '50px', height: '38px', padding: '3px' }}
                                            value={configForm.backgroundColor || '#050508'}
                                            onChange={(e) => setConfigForm({ ...configForm, backgroundColor: e.target.value })}
                                            onBlur={() => updateField('backgroundColor', configForm.backgroundColor)}
                                        />
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={configForm.backgroundColor || '#050508'}
                                            onChange={(e) => setConfigForm({ ...configForm, backgroundColor: e.target.value })}
                                            onBlur={() => updateField('backgroundColor', configForm.backgroundColor)}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="col-md-6 mb-3">
                                    <DragAndDropField 
                                        label={configForm.backgroundType === 'image' ? 'Imagen de Fondo' : 'Video de Fondo'}
                                        targetField="backgroundUrl"
                                        type={configForm.backgroundType === 'image' ? 'background' : 'video'}
                                        value={configForm.backgroundUrl}
                                        onUpload={handleUploadMedia}
                                        onClear={handleClearMedia}
                                        getMediaUrl={getMediaUrl}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Panel Derecho: Modos y Reglas */}
                <div className="col-md-5 mb-4">
                    <div className="bg-white p-4 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-between">
                        <div>
                            <h5 className="fw-bold mb-4 text-primary"><i className="bi bi-controller"></i> Reglas y Operación</h5>

                            {/* MODO ESCÁNER */}
                            <div className="form-check form-switch mb-4">
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="requireScanSwitch" 
                                    checked={configForm.requireScan}
                                    onChange={(e) => updateField('requireScan', e.target.checked)}
                                />
                                <label className="form-check-label fw-bold text-dark" htmlFor="requireScanSwitch">
                                    Requerir escaneo de abono (Modo Express si está desactivado)
                                </label>
                            </div>

                            {/* DURACIÓN DEL MENSAJE */}
                            <div className="mb-4">
                                <label className="form-label fw-bold text-dark">Duración del Mensaje de Bienvenida/Ganador (segundos):</label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    style={{ width: '120px' }}
                                    min="1"
                                    max="60"
                                    value={configForm.messageDuration || 5}
                                    onChange={(e) => setConfigForm({ ...configForm, messageDuration: parseInt(e.target.value) || 5 })}
                                    onBlur={() => updateField('messageDuration', configForm.messageDuration)}
                                />
                            </div>

                            <hr />

                            {/* REGLAS DE SELECCIÓN DE GANADOR */}
                            <label className="fw-bold d-block mb-2">Método de Premiación:</label>
                            <div className="d-flex gap-2 mb-3">
                                <button 
                                    className={`btn btn-sm ${configForm.winnerSelectionMode === 'Frequency' ? 'btn-primary' : 'btn-outline-primary'}`} 
                                    onClick={() => updateField('winnerSelectionMode', 'Frequency')}
                                >
                                    Frecuencia
                                </button>
                                <button 
                                    className={`btn btn-sm ${configForm.winnerSelectionMode === 'ExactPosition' ? 'btn-primary' : 'btn-outline-primary'}`} 
                                    onClick={() => updateField('winnerSelectionMode', 'ExactPosition')}
                                >
                                    Posición Exacta
                                </button>
                                <button 
                                    className={`btn btn-sm ${configForm.winnerSelectionMode === 'Manual' ? 'btn-primary' : 'btn-outline-primary'}`} 
                                    onClick={() => updateField('winnerSelectionMode', 'Manual')}
                                >
                                    Fuerza Manual
                                </button>
                            </div>

                            {/* Controles de método dinámicos */}
                            {configForm.winnerSelectionMode === 'Frequency' && (
                                <div className="mb-4">
                                    <label className="form-label small text-muted">Premiar a 1 de cada X personas:</label>
                                    <div className="input-group input-group-sm w-50">
                                        <input 
                                            type="number" 
                                            className="form-control fw-bold" 
                                            value={configForm.winnerFrequency}
                                            onChange={(e) => setConfigForm({ ...configForm, winnerFrequency: parseInt(e.target.value) || 0 })}
                                            onBlur={() => updateField('winnerFrequency', configForm.winnerFrequency)}
                                        />
                                        <span className="input-group-text">personas</span>
                                    </div>
                                </div>
                            )}

                            {configForm.winnerSelectionMode === 'ExactPosition' && (
                                <div className="mb-4">
                                    <label className="form-label small text-muted">Ej: "50,100,150" (separa con comas):</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-sm"
                                        placeholder="Ej: 50,100,150"
                                        value={configForm.exactWinnerPositions || ''}
                                        onChange={(e) => setConfigForm({ ...configForm, exactWinnerPositions: e.target.value })}
                                        onBlur={() => updateField('exactWinnerPositions', configForm.exactWinnerPositions)}
                                    />
                                </div>
                            )}

                            {configForm.winnerSelectionMode === 'Manual' && (
                                <div className="mb-4 bg-light p-3 rounded border text-center">
                                    <p className="small text-muted mb-3">Fuerza a que el siguiente participante en golpear el botón sea ganador</p>
                                    <button 
                                        className={`btn fw-bold w-100 ${configForm.nextClickIsWinner ? 'btn-danger animate-pulse' : 'btn-outline-danger'}`}
                                        onClick={() => updateField('nextClickIsWinner', !configForm.nextClickIsWinner)}
                                    >
                                        {configForm.nextClickIsWinner ? '🔴 Ganador manual activo' : 'Activar Ganador Siguiente Click'}
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* BOTÓN REINICIAR */}
                        <div className="mt-4 pt-3 border-top">
                            <span className="small text-muted d-block mb-2">Para ver la pantalla de acceso en tu proyector abre la ruta:</span>
                            <a href="/registro-asistencia" target="_blank" className="btn btn-outline-secondary w-100 fw-bold">
                                <i className="bi bi-box-arrow-up-right"></i> Abrir Pantalla de Registro
                            </a>
                        </div>
                    </div>
                    </div>
                </div>
            )}

            {/* TAB 2: HISTORIAL DE REGISTROS (CRUD) */}
            {activeTab === 'history' && (
                <div className="bg-white p-4 rounded-4 border shadow-sm text-start text-dark">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h4 className="fw-bold mb-1 text-primary"><i className="bi bi-clock-history"></i> Historial de Accesos</h4>
                            <span className="small text-muted">Administra, elimina y visualiza los abonos registrados correlativamente</span>
                        </div>
                        <button className="btn btn-sm btn-outline-primary fw-bold" onClick={loadRecords}>
                            <i className="bi bi-arrow-clockwise"></i> Actualizar Tabla
                        </button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped table-hover align-middle">
                            <thead className="table-dark">
                                <tr>
                                    <th>Asistencia #</th>
                                    <th>Código del Abono</th>
                                    <th>Fecha y Hora</th>
                                    <th>¿Resultó Ganador?</th>
                                    <th className="text-center" style={{ width: '150px' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {records.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-4 fs-5">
                                            No hay asistencias registradas aún.
                                        </td>
                                    </tr>
                                ) : (
                                    records.map(r => (
                                        <tr key={r.id}>
                                            <td className="fw-bold fs-5 text-primary">#{r.attendanceNumber}</td>
                                            <td><code>{r.subscriberCode}</code></td>
                                            <td>{new Date(r.registeredAt).toLocaleString()}</td>
                                            <td>
                                                {r.isWinner ? (
                                                    <span className="badge bg-success fs-6"><i className="bi bi-trophy-fill"></i> ¡Ganador!</span>
                                                ) : (
                                                    <span className="badge bg-secondary fs-6">Normal</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <button 
                                                    className="btn btn-sm btn-danger fw-bold shadow-sm" 
                                                    onClick={() => handleDeleteRecord(r.id)}
                                                    title="Eliminar registro y reordenar el resto"
                                                >
                                                    <i className="bi bi-trash"></i> Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </SecondaryBase>
    );
};
